import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/index/App.auth.jsx';
import store from './redux/store';
import { AppContainer } from 'react-hot-loader';

require('bootstrap-loader');
require('font-awesome-webpack');
require('simple-line-icons/css/simple-line-icons.css');
require('../scss/login.scss'); // eslint-disable-line global-require

// load images
require.context('../images/', true, /^\.\/.*\.png|jpg|gif/);

ReactDOM.render(
  <AppContainer>
    <App store={store} />
  </AppContainer>,
  document.getElementById('react-app')
);

if (module.hot) {
  module.hot.accept('./components/index/App.auth.jsx', () => {
    const NextApp = require('./components/index/App.auth.jsx').default; // eslint-disable-line

    ReactDOM.render(
      <AppContainer>
        <NextApp store={store} />
      </AppContainer>,
      document.getElementById('react-app')
    );
  });
}



/** WEBPACK FOOTER **
 ** ./js/auth.js
 **/